import axios from "axios";
import rootStore from "../store";

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASE_URL;

axios.interceptors.request.use(function(config) {
    if (rootStore.state.accessToken?.value)
        config.headers['Authorization'] = 'Bearer ' + rootStore.state.accessToken.value;
    if (rootStore.state.facilityId)
        config.params = {...config.params, userFacilityId: rootStore.state.facilityId};
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function(response) {
    return response;
}, function (error) {
    if ((!error.response || error.response.status === 401) && !rootStore.state.sessionLocked) {
        window.localStorage.removeItem(process.env.VUE_APP_ACCESS_TOKEN_KEY!);
    }
    return Promise.reject(error);
});
